export const formatPrice = (
  price,
  classs = "",
  iconsize = "12",
  iconColor = "#000000"
) => {
  if (!price || isNaN(price)) return "-";
  return (
    <span className={`inline-flex items-center gap-1 ${classs}`}>
      {/* <img src={AED} alt='AED' className='w-4 h-4' /> */}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={iconsize}
        height={iconsize}
        viewBox="0 0 116 101"
        fill="none"
      >
        <path
          d="M116 48L115 47C113.575 45.6416 111.832 45 110 45H101C101.136 46.6301 101 48.234 101 50C101 51.766 101.136 54.302 101 56H107C111.884 56 116 60.2266 116 66V69L115 68C113.575 66.7095 111.832 66 110 66H99C93.7766 88.8897 75.7626 101 47 101H10C10 101 15 96.9731 15 84V66H9C4.04796 66 0 60.7054 0 55V53L1 54C2.35672 55.2905 4.16842 56 6 56H15V45H9C4.04796 45 0 40.7054 0 35V32L1 33C2.35672 34.2905 4.16842 35 6 35H15V18C15 4.61937 10 0 10 0H47C74.9485 0 93.5053 11.9744 99 35H107C111.884 35 116 40.2266 116 46V48ZM46 5H30V35H82C78.4725 13.9442 66.8257 5 46 5ZM83 50C83 48.234 83.0678 46.6301 83 45H30V56H83C83.0678 54.302 83 51.766 83 50ZM30 96H46C68.0468 95.4566 78.676 85.0861 82 66H30V96Z"
          fill={iconColor}
        />
      </svg>

      <span>
        {Number(price).toLocaleString("en-AE", {
          maximumFractionDigits: 0,
        })}
      </span>
    </span>
  );
};

export const maskVinNumber = (value, visible = 8, maskChar = "*") => {
  if (value == null) return "";
  const str = String(value).trim();
  if (str.length <= visible) return str;
  return maskChar.repeat(str.length - visible) + str.slice(-visible);
};

export const formatNumber = (num) => {
  return new Intl.NumberFormat("en-AE").format(num);
};

export const getExpiryInfo = (issueDateStr) => {
  // Gate pass is valid for 7 days from issue date (including the issue date)
  // Returns: { expiryDateStr, dayOfWeek, daysRemaining, color }
  if (!issueDateStr) {
    return {
      expiryDateStr: "N/A",
      dayOfWeek: "",
      daysRemaining: null,
      color: "#6B7280", // gray
    };
  }
  const issueDate = new Date(issueDateStr);
  if (isNaN(issueDate.getTime())) {
    return {
      expiryDateStr: "Invalid date",
      dayOfWeek: "",
      daysRemaining: null,
      color: "#6B7280",
    };
  }
  // Expiry is 6 days after issue date (so 7 days total, including issue date)
  const expiryDate = new Date(issueDate);

  // Format expiry date as YYYY-MM-DD
  const expiryDateStr = expiryDate.toLocaleDateString("en-AE", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  // Day of week
  const dayOfWeek = expiryDate.toLocaleDateString("en-AE", {
    weekday: "short",
  });

  // Calculate days remaining (expiry date is inclusive)
  const today = new Date();
  // Zero out time for today and expiryDate for accurate day diff
  today.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);

  const msPerDay = 24 * 60 * 60 * 1000;
  const daysRemaining = Math.ceil((expiryDate - today) / msPerDay);

  // Color logic
  let color = "#059669"; // green
  if (daysRemaining < 0) {
    color = "#EF4444"; // red (expired)
  } else if (daysRemaining <= 2) {
    color = "#F59E42"; // orange (expiring soon)
  }

  console.log({
    expiryDateStr,
    dayOfWeek,
    daysRemaining: daysRemaining >= 0 ? daysRemaining : 0,
    color,
  });

  return {
    expiryDateStr,
    dayOfWeek,
    daysRemaining: daysRemaining >= 0 ? daysRemaining : 0,
    color,
  };
};

// PDF Generation Function for Gate Pass
export const downloadGatePassAsPDF = async (gatePass, user) => {
  try {
    // Dynamic import to avoid SSR issues
    const html2canvas = (await import("html2canvas")).default;
    const jsPDF = (await import("jspdf")).default;

    // Get the gate pass content element
    const element = document.getElementById("gate-pass-content");
    if (!element) {
      console.error("Gate pass content element not found");
      return;
    }

    // Create a temporary container for better PDF rendering
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.left = "-9999px";
    tempContainer.style.top = "0";
    tempContainer.style.width = "800px";
    tempContainer.style.backgroundColor = "white";
    tempContainer.style.padding = "20px";
    tempContainer.style.fontFamily = "Arial, sans-serif";

    // Clone the content
    const clonedElement = element.cloneNode(true);
    tempContainer.appendChild(clonedElement);
    document.body.appendChild(tempContainer);

    // Generate canvas from HTML
    const canvas = await html2canvas(tempContainer, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      width: 800,
      height: tempContainer.scrollHeight,
    });

    // Remove temporary container
    document.body.removeChild(tempContainer);

    // Create PDF
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    // Calculate dimensions
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgX = (pdfWidth - imgWidth * ratio) / 2;
    const imgY = 10;

    // Add image to PDF
    pdf.addImage(
      imgData,
      "PNG",
      imgX,
      imgY,
      imgWidth * ratio,
      imgHeight * ratio
    );

    // Generate filename
    const gatePassNumber =
      gatePass?.gatePassNumber || gatePass?.id || "unknown";
    const date = new Date().toISOString().split("T")[0];
    const filename = `gate-pass-${gatePassNumber}-${date}.pdf`;

    // Download PDF
    pdf.save(filename);
  } catch (error) {
    console.error("Error generating PDF:", error);
    // Fallback: try to install required packages
    alert(
      "PDF generation failed. Please ensure html2canvas and jspdf packages are installed."
    );
  }
};
